import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CloseSmallIcon, MenuIcon } from 'DesignSystem/Icons';
import { PrimaryButton, TertiaryButton } from '../DesignSystem/Buttons';

const MenuOption = React.memo(({ href, text, toggleMenu }) => (
  <div className="head-term-page-nav-item-wrapper-mobile" key={href}>
    <a href={href} onClick={toggleMenu}>
      <div className="head-term-page-nav-item head-term-page-nav-item-mobile">
        <div className="selected-indicator">
          <div className="selected-indicator-bar" />
          <div className="selected-indicator-arrow" />
        </div>
        {text}
      </div>
    </a>
  </div>
));

export class HeadTermStateMobileNavMenu extends React.PureComponent {
  static init(id, props) {
    ReactDOM.render(
      <HeadTermStateMobileNavMenu {...props} />,
      document.getElementById(id),
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
      menuItems: [],
    };

    this.onCreateClick = this.onCreateClick.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.getMenuAction = this.getMenuAction.bind(this);
    this.getMenuOptions = this.getMenuOptions.bind(this);
    this.cacheMenuItems = this.cacheMenuItems.bind(this);
  }

  componentDidMount() {
    // Cache menu items once on mount
    this.cacheMenuItems();

    window.addEventListener('resize', this.cacheMenuItems);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.cacheMenuItems);
  }

  onCreateClick() {
    window.location.assign(this.props.ctaLink);
  }

  getMenuOptions() {
    const navBarMenuClasses = classNames('navbar-menu-item-container', {
      hidden: !this.state.isMenuOpen,
    });

    return (
      <div className={navBarMenuClasses}>
        {this.state.menuItems.map(({ href, text }) => (
          <MenuOption
            key={href}
            href={href}
            text={text}
            toggleMenu={this.toggleMenu}
          />
        ))}
      </div>
    );
  }

  getMenuAction() {
    const actionText = this.state.isMenuOpen ? 'Close' : 'Menu';
    const ActionIconComponent = this.state.isMenuOpen
      ? CloseSmallIcon
      : MenuIcon;
    const actionIcon = (
      <ActionIconComponent
        className="ds-icon-default cursor-pointer
                    head-term-state-navbar-menu-icon"
      />
    );

    return (
      <div className="head-term-state-navbar-icon-wrapper">
        <TertiaryButton
          className="head-term-state-navbar-action"
          icon={actionIcon}
          onClick={this.toggleMenu}
          size="sm"
        >
          {actionText}
        </TertiaryButton>
      </div>
    );
  }

  cacheMenuItems() {
    const navBarItemElements = [
      ...document.querySelectorAll(
        '.head-term-page-nav-item:not(.head-term-page-nav-item-mobile)',
      ),
    ];

    // Process elements once and store results
    const menuItems = navBarItemElements
      .filter((el) => {
        const style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      })
      .map((e) => {
        const href = e.parentElement.href.match(/#.*$/)[0];
        const nbspRegEx = new RegExp(String.fromCharCode(160), 'g');
        const text = e.textContent.replace(nbspRegEx, ' ').replace(/^\s+/, '');

        return { href, text };
      });

    this.setState({ menuItems });
  }

  toggleMenu() {
    document
      .querySelector('body')
      .classList.toggle('head-term-state-nav-mobile-menu-open');
    this.setState(prevState => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));
  }

  render() {
    const navBarHeaderClasses = classNames(
      'head-term-state-navbar-header-mobile',
      { 'menu-open': this.state.isMenuOpen },
    );

    return (
      <div className="head-term-state-navbar-wrapper-mobile">
        <div className={navBarHeaderClasses}>
          {this.getMenuAction()}
          <PrimaryButton
            className="create-document-cta"
            onClick={this.onCreateClick}
            size="sm"
          >
            Create My Document
          </PrimaryButton>
        </div>
        {this.getMenuOptions()}
      </div>
    );
  }
}

HeadTermStateMobileNavMenu.propTypes = {
  ctaLink: PropTypes.string.isRequired,
};

export default HeadTermStateMobileNavMenu;



// WEBPACK FOOTER //
// ./src-react/HeadTermStateMobileNavMenu/index.jsx